import http from '../_http_v2';

const detect = {
  //default
  summary: (m) => { return http.get(`console/wsfinder/detect`, m); },
  list: (m) => { return http.post(`console/wsfinder/detect/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/detect/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/detect`, m); },
  update: (m) => { return http.put(`console/wsfinder/detect`, m); },
  delete: (m) => { return http.delete(`console/wsfinder/detect/${m.id}`); },
}

export default detect

export { detect }